import type { RuntimeKind } from '../types';
import type { PlatformDatabase } from './types';
import { RUNTIME_CAPABILITIES } from '../capabilities';

/**
 * PlatformDatabase (PLAN §5.2 / §2.1).
 *
 * The engine decision lives here and `PlatformDBService` consumes it, so the
 * `Unsupported platform` throw is unreachable for any known runtime. Engine
 * *construction* deliberately stays in `PlatformDBService` — moving the
 * `SQLiteService` / `DexieService` wiring into `src/platform` would create an
 * import cycle through `DB_Utils` for no benefit.
 *
 * Electron uses Dexie inside the shell's own origin, so it takes the `web`
 * database names (`MyDatabase` / `PointCraftOfflineDemo`). `'sqlite-electron'`
 * is reserved for Phase 2 and is not a value this table can produce.
 */
export function createPlatformDatabase(kind: RuntimeKind): PlatformDatabase {
  const capabilities = RUNTIME_CAPABILITIES[kind];
  return {
    engine: capabilities.localDatabase,
    databaseNameFlavour: capabilities.localDatabase === 'sqlite-native' ? 'native' : 'web',
    supportsDiagnosticLogRows: capabilities.deviceDiagnostics,
  };
}
